import { useDetailsOfExpensesReport } from './useDetailsOfExpensesReport';

export { useDetailsOfExpensesReport };
